import {Injectable} from '@angular/core';
import {Config} from '@services/infra/config';

@Injectable({
  providedIn: 'root',
})
export abstract class ConfigService {
  private conf: Config | null = null;

  /* Should only be used by APP_INITIALIZER */
  setConfig(newConf: Config): void {
    this.conf = newConf;
  }

  getConfig(): Config {
    console.assert(Boolean(this.conf), 'invalid state: getConfig() before setConfig()');
    return this.conf as Config;
  }

  get backendUrl(): string {
    return this.getConfig().backendUrl;
  }
  get logUrl(): string | null {
    return this.getConfig().logUrl;
  }
  get orderSamplePlaceholderTextUsers(): string {
    return this.getConfig().orderSamplePlaceholderTextUsers;
  }
  get baseHref(): string {
    return this.getConfig().baseHref;
  }
}
